import { useLocation, useNavigate } from 'react-router-dom';

const PASSCODE_STEP = 'passcodeStep';

const stateRecord = (state: unknown): Record<string, unknown> =>
  typeof state === 'object' && state !== null ? (state as Record<string, unknown>) : {};

export interface CodeStepHistory {
  readonly atCode: boolean;
  readonly openCode: () => void;
  readonly leaveCode: () => void;
}

export const useCodeStepHistory = (): CodeStepHistory => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = stateRecord(location.state);
  const atCode = state[PASSCODE_STEP] === 'code';
  return {
    atCode,
    openCode: () =>
      navigate(`${location.pathname}${location.search}${location.hash}`, {
        replace: atCode,
        state: { ...state, [PASSCODE_STEP]: 'code' },
      }),
    leaveCode: () => {
      if (atCode) navigate(-1);
    },
  };
};
